<template>
  <div class="jd-list-wrapper">
    <w-nav-bar nav_title="今日推荐" @mobileLeftBtn="toBack"/>
    <cube-scroll :data="jdList" v-if="!loadingShow">
      <job-list :list-data="jdList" :operation-show="true"/>
      <w-no-more/>
    </cube-scroll>
    <w-loading v-else/>
  </div>
</template>

<script>
	import WNavBar from '../../components/global/w-navbar'
	import jobList from '../job-components/job-list'
	import WLoading from '../../components/global/w-loading'
	import WNoMore from '../../components/global/w-no-more'
	import { mapActions, mapState } from 'vuex'
	import { windowEventMixin } from '../../assets/js/mixin/global'

	export default {
		name: 'recommend-list',
		mixins: [ windowEventMixin ],
		data () {
			return {
				loadingShow: true,
			}
		},
		beforeRouteEnter (to, from, next) {
			next(vm => {
				vm.getJdListData(from.name)
			})
		},
		computed: {
			...mapState('jobs', [ 'jdList' ])
		},
		watch: {},
		components: {
			jobList,
			WLoading,
			WNavBar,
			WNoMore
		},
		methods: {
			...mapActions('jobs', [ 'getJdJobsList' ]),
			// 获取自营职位列表数据
			async getJdListData (name) {
				if (name !== 'recommend-detail') {
					await this.getJdJobsList()
					this.loadingShow = false
				}
			},
			// 返回上个页面
			toBack () {
				this.$router.back()
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .jd-list-wrapper {
    height: calc(var(--vh, 1vh) * 100);
    padding-top: 44px;
    background-color: #f9f9f9;
    @include ipx-content-bottom(1px);
    /deep/ .recommend-item {
      padding: 20px 24px;
      margin-bottom: 6px;
    }
  }
</style>
